import { Button } from "@chakra-ui/button";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/menu";
import { Flex, Portal } from "@chakra-ui/react";
import { checkPermission } from "infra/helpers/permission";
import { GoKebabVertical } from "react-icons/go";

interface ActionsKebabMenuProps<T> {
  actions?: {
    invisible?: boolean;
    title: string | ((_v: T) => any);
    permission?: string | ((_v: T) => string);
    icon?: (_v: T) => any;
    onClick: (_v: T, index?: number) => void;
    shouldRender?: (original: T) => boolean;
    color?: string;
  }[];
  actionsContainerRef?: React.RefObject<HTMLElement | null> | undefined;
  item: T;
  indexItem: number | undefined;
}

export default function ActionsKebabMenu<T>({
  item,
  actions,
  actionsContainerRef,
  indexItem,
}: ActionsKebabMenuProps<T>) {
  actions =
    actions?.filter((action) => {
      if (typeof action.permission === "function") {
        return checkPermission(action.permission(item) as string);
      } else if (action.permission) {
        return checkPermission(action.permission);
      }

      if (action.invisible) {
        return false;
      }

      return true;
    }) ?? [];

  return (
    <Menu>
      <MenuButton
        onClick={(ev) => {
          ev.stopPropagation();
        }}
        type="button"
      >
        <Button
          variant="outline"
          rounded="full"
          w="40px"
          h="40px"
          type="button"
        >
          <GoKebabVertical />
        </Button>
      </MenuButton>
      <Portal containerRef={actionsContainerRef}>
        <MenuList>
          {actions?.map((action, index) =>
            (action.shouldRender ? action.shouldRender?.(item) : true) ? (
              <MenuItem
                key={index}
                fontSize="14px"
                onClick={(ev) => {
                  ev.preventDefault();
                  ev.stopPropagation();
                  action.onClick(item, indexItem);
                }}
                type="button"
              >
                <Flex
                  alignItems="center"
                  gridGap="8px"
                  flex={1}
                  color={action.color}
                >
                  {typeof action.icon === "function" ? action.icon(item) : null}
                  {typeof action.title === "function"
                    ? action.title(item)
                    : action.title}
                </Flex>
              </MenuItem>
            ) : null
          )}
        </MenuList>
      </Portal>
    </Menu>
  );
}
